export default "__VITE_ASSET__pnGsekWj__"